export enum StakingStatus {
  Funding = 0,
  InProgress = 1,
  Finished = 2,
  Canceled = 3,
}

export enum StakePeriodType {
  OneMonth = 1,
  ThreeMonths = 3,
  SixMonths = 6,
  TwelveMonths = 12,
}

export enum StakePeriodTypeLabel {
  "One month" = 1,
  "Three months" = 3,
  "Six months" = 6,
  "Twelve months" = 12,
}
